import React, { use, useEffect, useState } from "react";
import { Avatar, Box, Button, Stack } from "@mui/material";
import Grid from "@mui/material/Grid2";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import AddIcon from "@mui/icons-material/Add";
import { Typography } from "antd";
import LoginPageLogo from "../../assets/images/LoginPageLogo.png";
import { Padding } from "@mui/icons-material";
import Styles from "./FeedbackForm.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { getProjectByToken } from "../../services/feedbackForm.service";

const FeedbackSubmit = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dataReceived = location.state;

  return (
    <Box>
      {/* Header */}
      <Box className={Styles.Container}>
        <Typography
          style={{
            color: "white",
            fontSize: "24px",
            fontWeight: 700,
            marginLeft: "3%",
          }}
        >
          WSH
        </Typography>
        <Stack
          direction={"row"}
          sx={{
            justifyContent: "center",
            alignItems: "center",
            mr: "1%",
          }}
        >
          <Box
            sx={{
              position: "relative",
              display: "flex",
              alignItems: "center",
            }}
          >
            {/* Avatar component */}
            <Avatar
              sx={{
                height: "40px",
                // width: "40px",
                background: "white",
                color: "#00675d",
                paddingLeft: "10px", // Add space for the text
                paddingRight: "10px",
                marginRight: "-5px", // Negative margin to move Box to the right
                zIndex: 1, // Ensure Avatar is on top
              }}
            >
              {dataReceived?.contactName?.charAt(0)}
            </Avatar>
            {/* Box component */}
            <Box
              sx={{
                background: "#FFFFFF33",
                borderRadius: 5,
                height: "40px",
                width: "200px",
                maxWidth: "150px",
                color: "white",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                marginLeft: "-13%",
                zIndex: 2,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              <Typography style={{ paddingLeft: "7%", color: "white" }}>
                {dataReceived?.contactName?.length > 10
                  ? `${dataReceived?.contactName?.slice(0, 10)}...`
                  : dataReceived?.contactName}
              </Typography>
            </Box>
          </Box>
        </Stack>
      </Box>

      {/* Content */}
      <Stack className={Styles.Content}>
        <img src={LoginPageLogo} alt="Company Logo" style={{ width: 147 }} />
        <Typography
          style={{ fontWeight: 600, fontSize: "22px", marginTop: "20px" , fontFamily: "Open Sans, sans-serif" }}
        >
          Thank You, {dataReceived?.contactName}!
        </Typography>

        <Typography
          style={{
            fontWeight: 400,
            fontSize: "18px",
            alignItems: "center",
            color: "#000000",
            padding: "0px 20px",
            fontFamily: "Open Sans, sans-serif",
          }}
        >
          Your feedback for Workforce Solutions for {dataReceived?.projectName}
          has been successfully submitted.
        </Typography>
      </Stack>
    </Box>
  );
};

export default FeedbackSubmit;
